import { render, staticRenderFns } from "./FaqsUpdate.vue?vue&type=template&id=0141bd72&scoped=true&"
import script from "./FaqsUpdate.vue?vue&type=script&lang=js&"
export * from "./FaqsUpdate.vue?vue&type=script&lang=js&"
import style0 from "./FaqsUpdate.vue?vue&type=style&index=0&id=0141bd72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0141bd72",
  null
  
)

export default component.exports